var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlaylistSml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-484.000000, -648.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(484.000000, 648.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-7",
    cx: 2.5,
    cy: 10.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-7",
    cx: 2.5,
    cy: 18.5,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 1.5,
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 9.5,
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 17.5,
    width: 14,
    height: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlaylistSml);
export default __webpack_public_path__ + "static/media/icon-playlist-sml.14615679312e77dedbac19b17402a2d8.svg";
export { ForwardRef as ReactComponent };